import { render, staticRenderFns } from "./crumbs.vue?vue&type=template&id=d1e96f06&scoped=true&"
import script from "./crumbs.vue?vue&type=script&lang=js&"
export * from "./crumbs.vue?vue&type=script&lang=js&"
import style0 from "./crumbs.vue?vue&type=style&index=0&id=d1e96f06&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e96f06",
  null
  
)

export default component.exports